"use strict";
// Copyright 2020-2022 SubQuery Pte Ltd authors & contributors
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAsync = exports.mergeAsyncLast = exports.mergeAsync = void 0;
function mergeAsync(v1, v2, v3, v4) {
    return {
        loading: v1.loading || v2.loading || !!(v3 === null || v3 === void 0 ? void 0 : v3.loading) || !!(v4 === null || v4 === void 0 ? void 0 : v4.loading),
        error: v1.error || v2.error || (v3 === null || v3 === void 0 ? void 0 : v3.error) || (v4 === null || v4 === void 0 ? void 0 : v4.error),
        data: [v1.data, v2.data, v3 === null || v3 === void 0 ? void 0 : v3.data, v4 === null || v4 === void 0 ? void 0 : v4.data],
    };
}
exports.mergeAsync = mergeAsync;
function mergeAsyncLast(v1, v2) {
    return {
        loading: v1.loading || v2.loading,
        error: v1.error || v2.error,
        data: v2.data,
    };
}
exports.mergeAsyncLast = mergeAsyncLast;
function mapAsync(scope, data) {
    return Object.assign(Object.assign({}, data), { data: data.data ? scope(data.data) : undefined });
}
exports.mapAsync = mapAsync;
//# sourceMappingURL=utils.js.map